// Enums are dictionary of names versus numbers. This is so they work in the same way as C# enums (and other languages) which allow multiple names to have the same number.

let precisionEnum = {
    'Equal': 0,
    'LessThan': 1,
    'GreaterThan': 2
};

export default precisionEnum;
